import { SHARED_ERROR_AND_WARNING_VALUE } from './shared';

export const PAGES_VALUE_FIELDS = {
  DISABLED: 'disabled',
  ERROR: 'error',
  LOADING: 'loading',
  PATCHING: 'patching',
  WARNING: 'warning',
};

export const DEFAULT_PAGES_VALUE = {
  [PAGES_VALUE_FIELDS.DISABLED]: false,
  [PAGES_VALUE_FIELDS.ERROR]: { ...SHARED_ERROR_AND_WARNING_VALUE },
  [PAGES_VALUE_FIELDS.LOADING]: true,
  [PAGES_VALUE_FIELDS.PATCHING]: false,
  [PAGES_VALUE_FIELDS.WARNING]: { ...SHARED_ERROR_AND_WARNING_VALUE },
};
